module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "holder"
    }
  }, [_c('div', {
    staticClass: "links"
  }, [(_vm.prev) ? _c('router-link', {
    staticClass: "prev",
    attrs: {
      "to": _vm.prev.path
    }
  }, [_vm._v(" < prev ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "source",
    attrs: {
      "href": _vm.sourceHref
    }
  }, [_vm._v(" source ")]), _vm._v(" "), (_vm.next) ? _c('router-link', {
    staticClass: "next",
    attrs: {
      "to": _vm.next.path
    }
  }, [_vm._v(" next > ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-098bb42e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demos-navigation.vue
// module id = 119
// module chunks = 1